import React from 'react';
import classnames from 'classnames';
import './style.css';

const ListingStatus = ({ status, className }) => (
  <p
    className={classnames(`teacher-listing-status teacher-listing-status--${status} m-0`, {
      [className]: className
    })}
  >
    {status}
  </p>
);

export default ListingStatus;



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Listings/ListingStatus/index.js